<template>
   <div class="home" v-if="!isLoading">
    <c-banner/>
    <c-game-play/>
    <c-mobile-video/>
    <c-slider/>
    <c-shop/>
    <c-agatis-info />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBanner from '@/views/Home/Banner'
import cGamePlay from '@/views/Home/GamePlay.vue'
import cSlider from '@/views/Home/Slider.vue'
import cShop from '@/views/Home/Shop.vue'
import cMobileVideo from '@/views/Home/MobileVideo.vue'
import cAgatisInfo from '@/views/Home/AgatisInfo.vue'

export default {
  name: 'Home',
  components: {
    cBanner,
    cGamePlay,
    cSlider,
    cShop,
    cMobileVideo,
    cAgatisInfo
  },

  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
